import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${props => props.width};
  min-width: 150px;
  margin-bottom: 2em;
`;

export const Content = styled.div`
  width: fit-content;
  max-width: 90%;
  position: relative;
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const Image = styled.div`
  display: flex;
  margin: auto;
  background-image: ${props => `url(${props.image})`};
  background-position: center;
  background-size: cover;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: solid 2px ${props => props.color};

`;

export const HoverEffect = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color:rgba(0,0,0,0.7);
  opacity: 0;
  transition: opacity 0.3s 0s ease-in-out;
  
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`;

export const Temperature = styled(Typography)`
  font-size: 13px;
  font-weight: bold;
  text-align: center;
  color: white;
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  margin: auto;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${props => props.color};
`;

export const Name = styled(Typography)`
  font-size: 16px;
  text-align: center;
  text-transform: captalize;
  margin-top: 1em;
  max-width: 17ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Date = styled(Typography)`
  font-size: 16px;
  text-align: center;
`;

